/* DeleteAction.js */

"use strict";

const DEVICE_NAME_MAX_LENGTH = 60;

class DeleteAction {
    constructor(logger, gameEditor) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this.executeDeletion = this.executeDeletion.bind(this);
    }

    run() {
        let catalogName = this._gameEditor.getOsCatalog().name;
        let shortCatalogName = catalogName.length > DEVICE_NAME_MAX_LENGTH ? catalogName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…" : catalogName;
        return this._gameEditor
            .runQuickConfirmationActionWorkflow(
                {
                    message: 'Are you sure you want to permanently delete "' + shortCatalogName + '"?',
                    title: "Delete",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive"
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text"
                    }
                },
                this.executeDeletion
            )
            .finally(() => {
                if (this._gameEditor.currentEntityRemoved) {
                    this._gameEditor.currentEntityRemoved = false;
                    this._gameEditor.currentEntityDeleteInProgress = false;
                    this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                }
            });
    }

    executeDeletion() {
        return this._gameEditor
            .getOsCatalog()
            .delete()
            .catch((err) => {
                this._logger.warn({ error: err }, "DeleteAction.run() - Error");
                this._gameEditor.currentEntityDeleteInProgress = false;
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = ["$teve.logger", "gameEditor.gameEditor"];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete Catalog",
    shown: true,
    order: 2
};
